import React from "react";
import { FaInstagram, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import { openCookieSettings } from "../utils/cookieConsent";
import { trackContactClick } from "../utils/tracking";

const legalLinks = [
  { label: "Juridisch & vertrouwen", to: "/legal#legal" },
  { label: "Betaling", to: "/legal#payment" },
  { label: "Cookiebeleid", to: "/legal#cookies" },
  { label: "Algemene voorwaarden", to: "/legal#terms-conditions" },
  { label: "Gebruiksvoorwaarden", to: "/legal#terms-service" },
  { label: "Privacybeleid", to: "/legal#privacy" },
];

const navigationLinks = [
  { label: "Voorbereiding Defensie", to: "/voorbereiding-defensie" },
  { label: "Gratis voorbereidings-check", to: "/voorbereiding-check" },
  { label: "12-weeks Defensieprogramma", to: "/program" },
  {
    label: "Programma Veiligheidsdiensten",
    to: "/programma-veiligheidsdiensten",
  },
  { label: "Ervaringen", to: "/ervaringen" },
  { label: "Contact", to: "/contact#contact-form" },
];

const Footer = () => {
  const linkClassName =
    "text-[13px] md:text-sm text-mmTextMuted hover:text-mmAccent hover:underline underline-offset-4 transition py-1 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-mmFocus";
  const headingClassName =
    "font-display uppercase tracking-[0.18em] text-mmAccent text-xs md:text-sm mb-2.5 md:mb-4";
  const contactLinkClassName =
    "flex items-center gap-2.5 md:gap-3 text-[13px] md:text-sm text-mmTextMuted hover:text-mmAccent hover:underline underline-offset-4 transition py-1 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-mmFocus";

  return (
    <footer className="w-full bg-mmPage text-mmText border-t border-mmBorder">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pt-10 md:pt-14 pb-7 md:pb-8">
        <div className="grid gap-7 md:gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:items-start">
          {/* Brand */}
          <div className="text-left">
            <h3 className="font-display uppercase tracking-[0.12em] text-[28px] md:text-[44px] leading-[1.05] text-mmAccent">
              Mission
              <br />
              Movement
            </h3>

            <p className="mt-4 md:mt-5 text-[13px] md:text-base text-mmTextMuted leading-relaxed max-w-sm">
              Persoonlijke begeleiding en gestructureerde voorbereiding voor
              serieuze voorbereiding richting Defensie en veiligheidsdiensten.
            </p>
            <p className="mt-4 md:mt-5 text-[11px] md:text-xs uppercase tracking-widest text-mmTextMuted">
              KVK: <span className="font-medium">85486205</span>
            </p>
          </div>

          {/* Navigatie */}
          <div>
            <h4 className={headingClassName}>Navigatie</h4>
            <nav
              className="flex flex-col gap-0.5 md:gap-1"
              aria-label="Footer navigatie"
            >
              {navigationLinks.map((item) => (
                <Link key={item.to} to={item.to} className={linkClassName}>
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className={headingClassName}>Contact</h4>
            <p className="text-[13px] md:text-sm text-mmTextMuted leading-relaxed mb-2.5 md:mb-3">
              Vragen over jouw voorbereiding? <br></br>Neem contact op.
            </p>
            <div className="space-y-0.5 md:space-y-1">
              <a
                href="https://wa.me/31649171684"
                target="_blank"
                rel="noreferrer"
                className={contactLinkClassName}
                onClick={() =>
                  trackContactClick({ method: "whatsapp", location: "footer" })
                }
              >
                <FaWhatsapp className="text-mmAccent text-sm md:text-base" />
                <span>WhatsApp</span>
              </a>

              <a
                href="https://www.instagram.com/mission.movement"
                target="_blank"
                rel="noreferrer"
                className={contactLinkClassName}
                onClick={() =>
                  trackContactClick({ method: "instagram", location: "footer" })
                }
              >
                <FaInstagram className="text-mmAccent text-xs md:text-sm" />
                <span>Instagram</span>
              </a>

              <a
                href="mailto:mission.movement@outlook.com"
                className={contactLinkClassName}
                onClick={() =>
                  trackContactClick({ method: "email", location: "footer" })
                }
              >
                <FaEnvelope className="text-mmAccent text-xs md:text-sm" />
                <span>E-mail</span>
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className={headingClassName}>Legal & vertrouwen</h4>
            <nav
              className="flex flex-col gap-0.5 md:gap-1"
              aria-label="Legal links"
            >
              {legalLinks.map((item) => (
                <Link key={item.to} to={item.to} className={linkClassName}>
                  {item.label}
                </Link>
              ))}
              <button
                type="button"
                onClick={openCookieSettings}
                className={`${linkClassName} text-left`}
              >
                Cookie instellingen
              </button>
            </nav>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 md:mt-10 pt-5 md:pt-6 border-t border-mmBorder flex flex-col md:flex-row items-center justify-between gap-3 text-mmTextMuted text-xs md:text-sm">
          <p className="text-center md:text-left">
            © 2026 Mission Movement. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
